export default __webpack_public_path__ + "static/media/estructura1.31cb02da.png";